import { render, staticRenderFns } from "./OrderWhatsappModal.vue?vue&type=template&id=3a494d46&scoped=true"
import script from "./OrderWhatsappModal.vue?vue&type=script&lang=js"
export * from "./OrderWhatsappModal.vue?vue&type=script&lang=js"
import style0 from "./OrderWhatsappModal.vue?vue&type=style&index=0&id=3a494d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a494d46",
  null
  
)

export default component.exports